module.exports = __webpack_public_path__ + "img/man.ce5ef470.png";